import type { TurboPickupConfiguration } from 'src/graphql/queries/turboPickup'
import { isValidCmsLink } from 'src/utils/isValidCmsLink'

export type TurboPickupTag = {
  text: string
  linkUrl: string
}

const PICKUP_ID_PREFIX = 'decathlonpro_'

function withoutPickupIdPrefix(pickupId: string) {
  const normalizedPickupId = pickupId.trim()

  return normalizedPickupId.startsWith(PICKUP_ID_PREFIX)
    ? normalizedPickupId.slice(PICKUP_ID_PREFIX.length)
    : normalizedPickupId
}

function getPickupIdKeys(pickupId: string) {
  const idWithoutPrefix = withoutPickupIdPrefix(pickupId)

  if (!idWithoutPrefix) {
    return []
  }

  return [
    ...new Set([
      pickupId.trim(),
      idWithoutPrefix,
      `${PICKUP_ID_PREFIX}${idWithoutPrefix}`,
    ]),
  ]
}

export function getActiveTurboPickupTags(
  configurations: TurboPickupConfiguration[] = []
): Record<string, TurboPickupTag> {
  return configurations.reduce<Record<string, TurboPickupTag>>(
    (tags, config) => {
      if (
        config?.isActive !== true ||
        !config.pickupId ||
        !config.tagText ||
        !isValidCmsLink(config.linkUrl)
      ) {
        return tags
      }

      const tag = {
        text: config.tagText,
        linkUrl: config.linkUrl.trim(),
      }

      getPickupIdKeys(config.pickupId).forEach((pickupId) => {
        tags[pickupId] = tag
      })

      return tags
    },
    {}
  )
}
